import { generateUserAgentHeader, getRegistrationEndpoint, getTermsOfUseId, urls, } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const registerPatient = (register, osType, osVersion, app, appVersion, language, appHash) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            name: 'registerPatient',
            method: 'POST',
            url: urls.apiUrl + `v1/${getRegistrationEndpoint(app)}`,
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
                'X-Integrity-Token': appHash,
                'X-Bundle-ID': app,
            },
            data: {
                Email: register.email,
                Password: register.password,
                Country: register.country,
                FirstName: register.firstName,
                LastName: register.lastName,
                DateOfBirth: register.dateOfBirth,
                Language: language,
                GuardianFirstName: register.guardianFirstName,
                GuardianLastName: register.guardianLastName,
                consents: [
                    {
                        id: getTermsOfUseId(app),
                        action: 'accept',
                    },
                    {
                        id: 'pp',
                        action: 'accept',
                    },
                ],
            },
        })
            .then(() => {
            resolve();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const updatePassword = (updatePasswordData, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'PATCH',
            url: urls.apiUrl + `v1/accounts/${updatePasswordData.userID}/password`,
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                password: updatePasswordData.newPassword,
                secondaryAuthentication: {
                    email: updatePasswordData.emailConfirmation,
                    password: updatePasswordData.currentPassword,
                },
            },
        })
            .then(() => {
            resolve();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const updatePatient = (id, patient, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'PUT',
            url: urls.apiUrl + 'v1/patients/' + id,
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                FirstName: patient.firstName,
                LastName: patient.lastName,
                DateOfBirth: patient.dateOfBirth,
                GuardianFirstName: patient.guardianFirstName,
                GuardianLastName: patient.guardianLastName,
            },
        })
            .then(() => {
            resolve();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const getPatient = (patientId, osType = 'none', osVersion = 'none', app = 'none', appVersion = 'none') => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'GET',
            url: urls.apiUrl + 'v1/patients/' + patientId,
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
            },
            name: 'getPatient',
        })
            .then((result) => {
            if (result.data) {
                return resolve(result.data);
            }
            reject();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
